import React, { useState, useEffect } from "react";
import "./profile.scss";
import { backendService } from "../../services/backend.service";
import Moment from "react-moment";
import "moment/locale/es";
import { directoryInfoService } from "../../services/directoryService.service";
import { postulanteService } from "../../services/postulantJob.service";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {Button, Table, Tag} from "antd";
import moment from "moment";
const MySwal = withReactContent(Swal);

export const UserActivity = ({activeTab}) => {

    const [userActivity, setUserActivity] = useState([]);
    const [userDirectry, setUserDirectory] = useState([]);
    const [userPostulant, setUserPostulant] = useState([]);

    const deleteDirectory = (id) => {
        directoryInfoService.deleteDirectory(id)
            .then((dataDirectoryInfo) => {
                if (dataDirectoryInfo.active === false) {
                    MySwal.fire({
                        text: "El directorio ha sido dado de baja",
                        icon: "success",
                        allowOutsideClick: false
                    }).then(() => {
                        directoryInfoService.getMyDirectory()
                            .then((dataDirectoryInfo) => {
                                setUserDirectory(dataDirectoryInfo);
                            });
                    });
                } else {
                    MySwal.fire({
                        text: "No se pudo dar de baja",
                        icon: "error",
                        allowOutsideClick: false
                    });
                }
            })
            .catch((error) => {
                MySwal.fire({
                    text: "No se pudo dar de baja",
                    icon: "error",
                    allowOutsideClick: false
                });
            });
    };

    const columnsUserActivity = [
        {
            title: 'Tipo de actividad',
            dataIndex: 'type',
        },
        {
            title: 'Actividad',
            dataIndex: 'name',
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }),
        },
        {
            title: 'Fecha de término',
            dataIndex: 'expirationDate',
            sorter: (a, b) =>
                moment(a.expirationDate).unix() - moment(b.expirationDate).unix(),
            sortDirections: ['descend', 'ascend'],
            render: (text) => (
                <Moment locale="es" format="DD [de] MMMM [de] YYYY HH:mm [hrs]">
                    {text}
                </Moment>
            ),
        },
    ];

    const columnsUserDirectory = [
        {
            title: '#',
            dataIndex: 'directoryInfoId',
            sorter: (a, b) => a.directoryInfoId - b.directoryInfoId,
        },
        {
            title: 'Nombre completo',
            dataIndex: 'fullName',
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.fullName.localeCompare(b.fullName, 'es', { sensitivity: 'base' }),
        },
        {
            title: 'Vigencia',
            dataIndex: 'expirationDate',
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) =>
                moment(a.expirationDate).unix() - moment(b.expirationDate).unix(),
            render: (date) => (
                <Moment locale="es" format="DD [de] MMMM [de] YYYY HH:mm [hrs]">
                    {date}
                </Moment>
            ),
        },
        {
            title: 'Estatus',
            dataIndex: 'directoryInfoStatusName',
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) =>
                a.directoryInfoStatusName.localeCompare(b.directoryInfoStatusName, 'es', { sensitivity: 'base' }),
            render: (_, record) => (
                <Tag color={
                    record.directoryInfoStatusId === 1 ? "warning"
                        : record.directoryInfoStatusId === 2 ? "success"
                            : record.directoryInfoStatusId === 3 ? "error"
                                : "blue"
                }>
                    {record.directoryInfoStatusName}
                </Tag>
            ),
        },
        {
            title: 'Baja de servicio',
            dataIndex: 'directoryInfoStatusId',
            render: (_, record) =>
                record.directoryInfoStatusId === 2 ? (
                    <Button
                        htmlType="button"
                        size="small"
                        type="primary"
                        onClick={() => deleteDirectory(record.directoryInfoId)}
                    >
                        Dar de Baja
                    </Button>
                ) : null,
        },
    ];

    const columnsUserPostulant = [
        {
            title: '#',
            dataIndex: 'jobId',
            sorter: (a, b) => a.directoryInfoId - b.directoryInfoId,
        },
        {
            title: 'Cargo o área ',
            dataIndex: 'jobTitle',
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.fullName.localeCompare(b.fullName, 'es', { sensitivity: 'base' }),
        },
        {
            title: 'Lugar',
            dataIndex: 'jobLocation',
            sorter: (a, b) => a.categoryServiceName.localeCompare(b.categoryServiceName, 'es', { sensitivity: 'base' }),
        },
        {
            title: 'Categoría',
            dataIndex: 'jobCategory',
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => a.subCategoryServiceName.localeCompare(b.subCategoryServiceName, 'es', { sensitivity: 'base' }),
        },
        {
            title: 'Empresa',
            dataIndex: 'jobCompanyName',
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => moment(a.expirationDate).unix() - moment(b.expirationDate).unix(),
            render: (date) => (
                <Moment locale="es" format="DD [de] MMMM [de] YYYY HH:mm [hrs]">
                    {date}
                </Moment>
            ),
        },
        {
            title: 'Fecha de postulación',
            dataIndex: 'postulationDate', // para que pueda ordenar por el nombre
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => moment(a.postulationDate).unix() - moment(b.postulationDate).unix(),
            render: (text) => (
                <Moment locale="es" format="DD MMMM YYYY">{text.postulationDate}</Moment>
            ),
        },
    ];

    const expandable = {
        expandedRowRender: (record) => (
            <div>
                <p><strong>Categoría:</strong> {record.categoryServiceName || 'No disponible'}</p>
                <p><strong>Subcategoría:</strong> {record.subCategoryServiceName || 'No disponible'}</p>
            </div>
        ),
        rowExpandable: () => true, // opcional si todas las filas pueden expandirse
    };

    const [loading, setLoading] = useState(false);
    const [size, setSize] = useState('large');
    const [tableLayout, setTableLayout] = useState('unset');
    const [top, setTop] = useState('none');
    const [bottom, setBottom] = useState('bottomRight');
    const [ellipsis, setEllipsis] = useState(false);
    const [yScroll, setYScroll] = useState(false);
    const [xScroll, setXScroll] = useState('unset');

    const scroll = {};

    if (yScroll)
        scroll.y = 240;

    if (xScroll !== 'unset')
        scroll.x = '100vw';

    const tableColumns = columnsUserActivity.map(item => Object.assign(Object.assign({}, item), { ellipsis }));

    if (xScroll === 'fixed') {
        tableColumns[0].fixed = true;
        tableColumns[tableColumns.length - 1].fixed = 'right';
    }

    const tableProps = {
        bordered: false,
        loading,
        size,
        expandable: false,
        title: false,
        showHeader: true,
        footer: true,
        rowSelection: {},
        scroll,
        tableLayout: tableLayout === 'unset' ? undefined : tableLayout,
    };

    useEffect(() => {
        backendService.userProfileActivity(false).then((data) => {
            setUserActivity(data);
        });

        directoryInfoService.getMyDirectory().then((data) => {
            setUserDirectory(data);
        });

        postulanteService.GetByUserId(localStorage["userId"]).then((data) => {
            setUserPostulant(data);
        });
    }, []);

    return (
        <div className="tabs-user">
            <>
                {activeTab === '1' && <div>
                    <h2>Historial de actividades</h2>
                    <Table
                        {...tableProps}
                        expandable={false}
                        pagination={{ position: [top, bottom] }}
                        columns={columnsUserActivity}
                        dataSource={userActivity}
                        scroll={scroll}
                        rowSelection={false}
                        locale={{ emptyText: 'No hay registros disponibles' }}
                        footer={false}
                    />
                </div>}
                {activeTab === '2' && <div>
                    <h2>Lista de servicios anunciados</h2>
                    <Table
                        {...tableProps}
                        expandable={expandable}
                        pagination={{ position: [top, bottom] }}
                        columns={columnsUserDirectory}
                        dataSource={userDirectry}
                        scroll={scroll || { x: true }}
                        rowSelection={false}
                        footer={false}
                        locale={{ emptyText: 'No hay registros disponibles' }}
                    />
                </div>}
                {activeTab === '3' && <div>
                    <h2>Lista de mis postulaciones</h2>
                    <Table
                        {...tableProps}
                        expandable={false}
                        pagination={{ position: [top, bottom] }}
                        columns={columnsUserPostulant}
                        dataSource={userPostulant}
                        scroll={scroll}
                        rowSelection={false}
                        footer={false}
                        locale={{ emptyText: 'No hay registros disponibles' }}
                    />
                </div>}
            </>
        </div>
    );
}
